import { useContext } from 'react';
import { TranslationContext } from '.';

export const useTranslation = () => {
  return useContext(TranslationContext);
};
